import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal, ModalHeader, ModalBody, Spinner } from "reactstrap";
import ContenedorRastreo from "../../views/Contenedores/Contenedores/ContenedorRastreo";

const URL_ALERTAS = process.env.REACT_APP_URL_ALERTAS;
const CACHE = "alertas-equipo";
const CADA_MS = 10 * 60 * 1000;
const auth = () => ({ Authorization: `Bearer: ${localStorage.getItem("app_token")}` });

const leeCache = () => {
  try {
    const c = JSON.parse(sessionStorage.getItem(CACHE));
    return c && Date.now() - c.ts < CADA_MS ? c.data : null;
  } catch (_) {
    return null;
  }
};

// Alertas para el equipo (sidebar): sin rastreo, cambio de ETA o buque, días libres por vencer
// y documento faltante después de zarpar. Clic en un contenedor = su rastreo e historial.
export default function Alertas() {
  const [data, setData] = useState(leeCache);
  const [abierto, setAbierto] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [grupo, setGrupo] = useState("");
  const [rastreoId, setRastreoId] = useState(null);

  const carga = () => {
    setCargando(true);
    axios
      .get(URL_ALERTAS, { headers: auth() })
      .then(({ data: d }) => {
        setData(d);
        try { sessionStorage.setItem(CACHE, JSON.stringify({ ts: Date.now(), data: d })); } catch (_) {}
      })
      .catch(() => {})
      .finally(() => setCargando(false));
  };

  useEffect(() => {
    if (!data) carga();
    const id = setInterval(carga, CADA_MS);
    return () => clearInterval(id);
  }, []); // eslint-disable-line

  const total = data ? data.total : 0;
  const grupos = data ? data.grupos : [];
  const activo = grupos.find((g) => g.tipo === grupo) || grupos.find((g) => g.items.length) || grupos[0];

  return (
    <>
      <button type="button" className="sidebar-alertas" onClick={() => { setAbierto(true); carga(); }} title="Alertas del equipo">
        <span className="sidebar-tc-icon"><i className="fas fa-bell" /></span>
        <span className="sidebar-tc-body">
          <span className="sidebar-tc-label">Alertas</span>
          <span className="sidebar-tc-valor">{data ? (total ? `${total} pendientes` : "Todo en orden") : "…"}</span>
        </span>
        {total ? <span className="alertas-badge">{total > 99 ? "99+" : total}</span> : null}
      </button>

      <Modal size="lg" isOpen={abierto} toggle={() => setAbierto(false)}>
        <ModalHeader toggle={() => setAbierto(false)}>
          <i className="fas fa-bell" style={{ color: "#d97706", marginRight: 8 }} /> Alertas del equipo
          {cargando ? <Spinner size="sm" style={{ marginLeft: 10 }} /> : null}
        </ModalHeader>
        <ModalBody>
          <div className="alertas-tabs">
            {grupos.map((g) => (
              <button
                key={g.tipo}
                type="button"
                className={`alertas-tab${activo && activo.tipo === g.tipo ? " on" : ""}`}
                onClick={() => setGrupo(g.tipo)}
              >
                <i className={g.icon} /> {g.titulo}
                <span className={`badge-soft badge-soft-${g.items.length ? g.color : "secondary"}`}>{g.items.length}</span>
              </button>
            ))}
          </div>
          {!activo ? (
            <div className="rc-state"><Spinner /><div>Cargando…</div></div>
          ) : activo.items.length === 0 ? (
            <div className="rc-state"><i className="fas fa-check-circle" /><div>Sin alertas</div></div>
          ) : (
            <div className="alertas-lista">
              {activo.items.slice(0, 200).map((it, i) => (
                <button key={`${it._id}-${i}`} type="button" className="alertas-item" onClick={() => setRastreoId(it._id)}>
                  <span className="alertas-cont">{it.referencia}<small>{it.numeroReferencia}</small></span>
                  <span className="alertas-cliente">{it.cliente || "—"}</span>
                  <span className="alertas-detalle">{it.detalle}</span>
                  <span className="alertas-fecha">{it.fecha}</span>
                </button>
              ))}
              {activo.items.length > 200 ? <div className="td-muted">Mostrando 200 de {activo.items.length}</div> : null}
            </div>
          )}
        </ModalBody>
      </Modal>

      <ContenedorRastreo isOpen={!!rastreoId} toggle={() => setRastreoId(null)} contenedorId={rastreoId} />
    </>
  );
}
